import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useGetProductListForStorefront } from "../../../../hooks/api/queries";
import { cleanObject } from "../../../../helpers";
import { ToastContext } from "../../../../hooks/context";
import {
  useCreateStorefront,
  useUpdateStorefront,
} from "../../../../hooks/api/mutations/useStorefront";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";

const reArrange = (selectedStorefrontProduct = []) => {
  const storefront_items = {};

  selectedStorefrontProduct?.forEach((item) => {
    storefront_items[
      `${item.product_id || item.service_id}${item.variant_id || ""}`
    ] = cleanObject({
      service_id: item.service_id ?? null,
      product_id: item.product_id ?? null,
      variant_id: item.variant_id ?? null,
      pricing_type_id: 1,
    });
  });

  return storefront_items;
};

export const useStorefrontDetailsForm = ({
  isEditMode = false,
  storefrontDetails,
  selectedStorefrontProduct = [],
}) => {
  const triggerToast = useContext(ToastContext);
  const navigate = useNavigate();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [queryParams, setQueryParams] = useState({
    query: "",
  });
  const [formData, setFormData] = useState({
    name: storefrontDetails?.name || "",
    store: storefrontDetails?.store?.id || "",
    storefront_items: reArrange(selectedStorefrontProduct),
  });

  const {
    isLoading: isFetchingProduct,
    data: productList = [],
    isFetchingNextPage,
    autoScrollRef,
  } = useGetProductListForStorefront({
    queryParams: cleanObject({
      ...queryParams,
      store_id: formData?.store,
    }),
    isEnabled: formData?.store ? true : false,
  });

  const { mutate: createStorefront, isLoading: isCreating } =
    useCreateStorefront();
  const { mutate: updateStorefront, isLoading: isUpdating } =
    useUpdateStorefront({
      id: storefrontDetails?.id,
    });
  const handleStorefront = () => {
    if (Object?.keys(formData?.storefront_items)?.length === 0)
      return triggerToast(
        "You haven't selected any item(s). Please select at least one item to continue",
      );

    if (!isEditMode)
      return createStorefront(
        cleanObject({
          ...formData,
          storefront_items: getStorefrontItems(),
          template_in_use: "template-2",
        }),
        {
          onSuccess: (res) => {
            navigate(
              pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_CHECKOUT({
                menuId: res?.data?.data?.id,
              }),
            );
          },
        },
      );

    updateStorefront(
      {
        menuId: storefrontDetails?.id,
        data: cleanObject({
          ...formData,
          storefront_items: getStorefrontItems(),
        }),
      },
      {
        onSuccess: (res) => {
          triggerToast("Storefront updated successfully", "success");

          navigate(
            pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_CHECKOUT({
              menuId: res?.data?.data?.id,
            }),
          );
        },
      },
    );
  };

  const filterBySearch = (val) => {
    setQueryParams((prev) => ({ ...prev, query: val }));
  };

  const getStorefrontItems = () => {
    const storefrontItems = Object.values(formData?.storefront_items || {});
    return storefrontItems;
  };

  return {
    isCreating: isCreating || isUpdating,
    isFetchingProduct,
    formData,
    storeList,
    // pricingTypes,
    queryParams,
    isFetchingNextPage,
    productList,
    autoScrollRef,
    setFormData,
    handleStorefront,
    filterBySearch,
  };
};
